import { MaticPOSClient } from '@maticnetwork/maticjs';

const CHAIN_ID = parseInt(process.env.REACT_APP_CHAIN_ID);
const config = require('./config');

export const getMaticPOSClient = (selectedAccount, web3) => {
  try {
    return new MaticPOSClient({
      network: CHAIN_ID === 1 ? 'mainnet' : 'testnet', // optional, default is testnet
      version: CHAIN_ID === 1 ? 'v1' : 'mumbai', // optional, default is mumbai
      parentProvider: web3,
      posRootChainManager: config.root.POSRootChainManager,
      posERC20Predicate: config.root.posERC20Predicate, // optional, required only if working with ERC20 tokens
      posERC721Predicate: config.root.posERC721Predicate, // optional, required only if working with ERC721 tokens
      posERC1155Predicate: config.root.posERC1155Predicate, // optional, required only if working with ERC71155 tokens
      parentDefaultOptions: { from: selectedAccount }, // optional, can also be sent as last param while sending tx
      maticDefaultOptions: { from: selectedAccount }, // optional, can also be sent as last param while sending tx
    });
  } catch (err) {
    console.log('Client error', err);
  }
};
